import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimaldisplay',
})
export class DecimalDisplayPipe implements PipeTransform {
    transform(val: number): string {
        // Format the output to display any way you want here.
        if (val !== undefined && val != null) {
            // val.toLocaleString not supported by safari
            const f = val.toFixed(2);
            return f.replace('.', ',');
        } else {
            return '';
        }
    }
}
